<template>
  <section>
    <div class="content_bg">

      <div style="position:absolute;top:0;height:200px;width:100%;background-color:#ecf3fa;">
      </div>

      <div style="position:absolute;margin-top: -150px;">
<svg width="2880px" height="1149px" viewBox="0 0 2880 1149" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="html" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="bg" transform="translate(0.000000, -1896.000000)" fill="#ECF3FA">
            <path d="M1440,1896 C1967.05136,1896 2441.89196,1966.408 2774.88247,2078.99057 L2880,2079 L2880.0162,2117.84452 C3120.66358,2215.18753 3264,2337.57153 3264,2470.5 C3264,2787.78759 2447.36738,3045 1440,3045 C432.632616,3045 -384,2787.78759 -384,2470.5 C-384,2337.57134 -240.663175,2215.18719 -0.0151880286,2117.84411 L0,2079 L105.117525,2078.99057 C438.108042,1966.408 912.948644,1896 1440,1896 Z" id="Combined-Shape"></path>
        </g>
    </g>
</svg>
    </div>

      <div class="content">
        <div>
          <CaptionGreen label="프로젝트 진행 방식"></CaptionGreen>
          <br/>
          <p style="font-weight: 300; font-size: 18px">
            먼데이리스는 기획 · 디자인 · 개발을 직접 수행합니다
          </p>
        </div>

        <div class="bbb">
          <div style="width: 288px">
            <img width="100%" src="@/assets/images/project_step_img1.png" />
            <p style="font-weight: 700; font-size: 24px">
              요구사항 구체화
            </p>
            <p style="font-weight: 300; font-size: 16px">
              앱 서비스의 전문가 집단으로서 요구사항을 분석하고 컨설팅해드립니다
            </p>
          </div>
          <div style="width: 288px">
            <img width="100%" src="@/assets/images/project_step_img2.png" />
            <p style="font-weight: 700; font-size: 24px">기능은 능동적으로</p>
            <p style="font-weight: 300; font-size: 16px">
              능동적으로 Feature를 제시하고 고객의 요구사항을 수용합니다.
            </p>
          </div>
          <div style="width: 288px">
            <img width="100%" src="@/assets/images/project_step_img3.png" />
            <p style="font-weight: 700; font-size: 24px">
              한정된 예산에서 기능 극대화
            </p>
            <p style="font-weight: 300; font-size: 16px">
              한정된 예산 안에서 타업체 대비 최대의 아웃풋을 제공합니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import client from "../client/client";

export default {
  components: {
    Caption,
    CaptionGreen,
  },
  mounted() {},
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 799px;
  position: relative;
  overflow: hidden;
  padding-top: 100px;
  background-color: #ffffff;
}

.content {
  position: absolute;
  width: 1140px;
  max-width: 1140px;
  text-align: center;
  padding-left: 20px;
  padding-right: 20px;
}

.bbb {
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  margin-bottom: 150px;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    justify-content: center;
    width: 100vw;
    height: fit-content;
    position: relative;
    overflow: hidden;
    background-color: #ecf3fa;
  }

  .content {
    position: relative;
    width: 100%;
    text-align: center;
  }

  .bbb {
    text-align: center;
    display: inline-block;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 150px;
  }
}
</style>
  